<div *ngIf="isRouteSelected" class="col-md-12">
    <i style="font-size: 11px; padding-bottom: 10px; display: block;">Note: Select either only one from below time fields.  Ex: If you already selected pivot and selecting the start time then pivot details will be cleared. Same for other fields.</i>
    <app-form [templateSource]="pivotFormTemplate" [configs]="pivotCreateConfig">
    </app-form>
</div>

<div>
    <app-cue-table *ngIf="shuttleTripRouteTableColumnConfigs" [dataset]="shuttleTripRouteTableDatasource" [gridOptions]="shuttleTripRouteTableConfigs" [columnDefinitions]="shuttleTripRouteTableColumnConfigs" [callback]="gridCallBacks" (onTableCellClicked)="onCellClickOnShuttleModal($event)"></app-cue-table>
</div>

<div *ngIf="(config.data.isShuttleRoute)" class="modal-footer2 col-md-12 align-right route-btn-shuttle">
    <button *ngIf="viewCalculate" class="btn btn-primary" style="margin-left: -30px;" (click)="onClickCalculate()">Calculate</button>
    <button *ngIf="viewSave" class="btn btn-primary margin-right-10 align-right" (click)="onClickSave()">Save</button>
    <button class="btn btn-primary  align-right" (click)="onCloseShuttleRouteModal()">Close</button>
</div>

<div *ngIf="(config.data.target === 'ROUTE_CODE')" class="modal-footer2 col-md-12 align-right route-btn-shuttle">
    <button *ngIf=false class="btn btn-primary" style="margin-left: -30px;" (click)="onTripAmend()">Amend Trips</button>
    <button class="btn btn-primary margin-right-10 align-right" (click)="onClickSave()">Save</button>
    <button class="btn btn-primary  align-right" (click)="onCloseShuttleRouteModal()">Close</button>
</div>